import { render } from "./FormDataTableMV2.vue?vue&type=template&id=8dba807e&scoped=true"
import script from "./FormDataTableMV2.vue?vue&type=script&lang=js"
export * from "./FormDataTableMV2.vue?vue&type=script&lang=js"

import "./FormDataTableMV2.vue?vue&type=style&index=0&id=8dba807e&scoped=true&lang=css"

import exportComponent from "/builds/uf-manage/mobile/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8dba807e"]])

export default __exports__